import React, { useState } from 'react';
import 'react-phone-number-input/style.css';
import { InputComponent } from '../../core/Forms';
import PhoneInput from 'react-phone-number-input';

interface ViewProps {
  formData: {
    firstName: string;
    lastName: string;
    businessName: string;
    industry: string;
    email: string;
    phone: string;
    address: string;
    state: string;
    city: string;
    businessSize: string;
    brandLogo: string;
    brandColor: string;
  };
}

export const View: React.FC<ViewProps> = ({ formData }) => {
  const [phone, setPhone] = useState<any>('');
  const [selectedValue, setSelectedValue] = useState(formData.industry);
  const [selectedValue2, setSelectedValue2] = useState(formData.businessSize);
  const [city, setCity] = React.useState(formData.city);
  const [state, setState] = React.useState(formData.state);
  const [FormData, setFormData] = useState();

  return (
    <>
      {/* Mobile/Tablet */}
      <div className="bg-[#FFFFFF] pt-[24px] w-[350px] md:w-full block lg:hidden">
        <hr className="" />
        <div className="block lg:hidden md:w-full">
          <div className="flex flex-col gap-y-72">
            <h1 className="text-left pl-[20px] md:pl-[80px] text-[14px] md:ml-[9em] mt-[1em] pb-[24px] ">
              Business & Personal information
            </h1>
          </div>
          <form>
            <div className="flex flex-col ">
              <div className="flex flex-col md:flex-row justify-center gap-[13px] items-center">
                <div className="flex flex-col  w-[310px] md:w-[210px] mx-[20px] md:mx-0">
                  <label htmlFor="first-name" className="text-[12px] text-[#666666] font-normal">
                    First Name
                  </label>
                  <div className="w-full">
                    <InputComponent
                      name="firstName"
                      value={formData.firstName}
                      disabled
                      className=" border bg-[#F2F2F2] border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px] rounded md:px-10  mb-[16px] w-[310px] md:w-full"
                      type="text"
                      placeholder="Kelly"
                    />
                  </div>
                </div>

                <div className="flex flex-col md:items-start  w-[310px] md:w-[210px] mx-[20px] md:mx-0">
                  <label htmlFor="first-name" className="text-[12px] text-[#666666] font-normal">
                    Last Name
                  </label>
                  <div className="w-full">
                    <InputComponent
                      name="lastName"
                      className="border bg-[#F2F2F2] border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px] rounded md:p-2 w-full mb-[16px]"
                      type="text"
                      placeholder="Audu"
                      value={formData.lastName}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col w-full justify-center items-center">
                <div className="flex flex-col w-[310px] mx-[20px] md:mx-0 items-start md:w-[434px]">
                  <label htmlFor="businessName" className="text-[12px] text-[#666666] font-normal">
                    Business Name
                  </label>
                  <div className="w-full">
                    <InputComponent
                      name="businessName"
                      className=" cursor-default border bg-[#F2F2F2] border-[#138EFF] placeholder:text-[1rem] w-[310px] placeholder:text-[#000000] placeholder:font-normal h-[48px] mb-[16px] rounded p-2 md:w-[434px]"
                      type="text"
                      value={formData.businessName}
                      disabled
                      placeholder="Business Name"
                    />
                  </div>
                </div>

                <div className="flex flex-col w-[310px] items-start  md:w-[434px]">
                  <label htmlFor="Category " className="text-[12px] text-[#666666] font-normal">
                    Category
                  </label>
                  <div className="w-full">
                    <InputComponent
                      name="industry"
                      className=" cursor-default border bg-[#F2F2F2] border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px] mb-[16px] rounded p-2 w-[310px] md:w-[434px]"
                      type="text"
                      value={formData.industry}
                      disabled
                      placeholder="Category"
                    />
                  </div>
                </div>

                <div className="flex flex-col w-[310px] items-start  md:w-[434px]">
                  <label htmlFor="businessSize " className="text-[12px] text-[#666666] font-normal">
                    Business Size
                  </label>
                  <div className="w-full">
                    <InputComponent
                      name="businessSize "
                      className=" cursor-default border bg-[#F2F2F2] border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px] mb-[16px] rounded p-2 w-[310px] md:w-[434px]"
                      type="text"
                      value={formData.businessSize}
                      disabled
                      placeholder="Business Size "
                    />
                  </div>
                </div>
              </div>
              <hr className="border-b-2 w-[1000px] mt-[1em] ml-[-2em]" />

              <h1 className="text-left pl-[20px] md:pl-[80px] md:ml-[11em] lg:pl-0 text-[14px] mt-[2em] pb-[4px] lg:pb-0">
                Contact information
              </h1>
              <div className="flex flex-col justify-center items-center">
                <div className="flex flex-col md:items-start mt-5 w-[310px] md:w-[434px]">
                  <label htmlFor="first-name" className="text-[12px] text-[#666666] font-normal">
                    Email
                  </label>
                  <div className="w-full ">
                    <InputComponent
                      name="email"
                      className="border  border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px] bg-[#F2F2F2] rounded p-2 w-[310px] md:w-[434px] mb-[16px]"
                      type="text"
                      placeholder="Kelz4U@primaboost.com"
                      value={formData.email}
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-col  items-start w-[310px] md:w-[434px] mb-[16px]">
                  <label htmlFor="phone-number" className="text-[12px] text-[#666666] font-normal ">
                    Phone Number
                  </label>
                  <div className="flex w-full h-[43px] border border-[#138EFF] bg-[#F2F2F2] rounded pl-2">
                    <PhoneInput
                      defaultCountry="NG"
                      className=" flex-1 w-[310px] md:w-[434px] h-fit rounded-lg gap-2 text-bold focus:outline-width-0 mb-[16px] "
                      value={formData.phone}
                      onChange={(phone) => setPhone(phone)}
                      placeholder="+234 081 8644 1442"
                      disabled
                    />
                  </div>
                </div>

                <div className="flex flex-col w-[310px] md:w-[434px]">
                  <label htmlFor="Address" className="text-[12px] text-[#666666] font-normal ">
                    Address
                  </label>
                  <div className="w-full">
                    <InputComponent
                      name="address"
                      className="border  border-[#138EFF] bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px]  rounded p-2 w-[310px] md:w-[434px] mb-[16px]"
                      type="text"
                      value={formData.address}
                      placeholder="Address"
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-col w-[310px] md:w-[434px]">
                  <label htmlFor="State" className="text-[12px] text-[#666666] font-normal">
                    State
                  </label>
                  <div className="w-full">
                    <InputComponent
                      name="state"
                      className="border  border-[#138EFF] bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px]  rounded p-2 w-[310px] md:w-[434px] mb-[16px]"
                      type="text"
                      value={formData.state}
                      placeholder="State"
                      disabled
                    />
                  </div>
                </div>
                <div className="flex flex-col w-[310px] md:w-[434px]">
                  <label htmlFor="City" className="text-[12px] text-[#666666] font-normal">
                    City
                  </label>
                  <div className="w-full">
                    <InputComponent
                      name="city"
                      className="border  border-[#138EFF] bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px]  rounded p-2 w-[310px] md:w-[434px] mb-[36px]"
                      type="text"
                      value={formData.city}
                      placeholder="City"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <hr className="border-b-1 w-[1000px] mt-[1em] ml-[-2em]" />
              <h1 className="text-left pl-[20px] md:pl-[80px] md:ml-[11em] lg:pl-0 text-[14px] mt-[2em] pb-[4px] lg:pb-0">
                Brand Identity
              </h1>

              <div className="w-64 mt-2 ml-[1.3em] md:ml-[10em] ">
                <label htmlFor="City" className="text-[13px] text-[#666666] font-normal mt-5">
                  Logo
                </label>
                <div className="mt-4 h-[40px] w-[191px]">
                  <img src={formData.brandLogo} alt="Logo" className="w-64 h-64 object-contain" />
                </div>
              </div>

              <div className="mt-[6em] mb-[2em] ml-[1.3em] md:ml-[10em]">
                <label htmlFor="color-input" className="text-sm text-gray-600 font-normal">
                  Brand Color
                </label>
                <div className="mt-[-1em]">
                  <input
                    type="text"
                    id="color-input"
                    className="mt-[1em] bg-white border border-gray-300 rounded-md ml-[4em] w-[100px]"
                    value={formData.brandColor}
                    readOnly
                  />
                  {formData.brandColor && (
                    <div
                      className="ml-[1em] mt-[-2em] w-6 h-6 rounded-md"
                      style={{ backgroundColor: formData.brandColor }}
                    ></div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {/* end of mobile/tablet view */}

      <div className="hidden lg:flex w-full ml-[1px] mt-[-25px] gap-[20px] md:pr-[64px] justify-between">
        <div className="flex flex-col gap-y-72">
          <h1
            className=" flex flex-col ml-[60px] md:ml-[83px] lg:ml-[2.5em] text-[1rem] mt-[3em] items-start"
            style={{ whiteSpace: 'nowrap' }}
          >
            Business & Personal information
          </h1>
          <h3 className=" flex flex-col ml-[60px] md:ml-[83px] items-start" style={{ whiteSpace: 'nowrap' }}>
            Contact Information
          </h3>

          <h3 className=" flex flex-col ml-[60px] md:ml-[83px] mt-[12em] items-start" style={{ whiteSpace: 'nowrap' }}>
            Brand Identity
          </h3>
        </div>

        <form>
          <div className="flex flex-col mt-[2em]">
            <hr className="border-t-1" />
            <div className=" w-[100%] justify-center   mb-[] gap-[5px]">
              <div className=" flex gap-[5px] placeholder:text-[13.25px] h-[48px] mb-[16px] rounded mt-[16px] w-full ">
                <div className="flex flex-col items-start  xl:w-[205px] lg:w-[180px] ">
                  <label htmlFor="first-name" className="text-[13px] text-[#666666] font-normal">
                    First Name
                  </label>
                  <div className="w-full">
                    <InputComponent
                      name="firstName"
                      value={formData.firstName}
                      disabled
                      className=" border bg-[#F2F2F2] border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px] rounded px-10  mb-[16px] w-full"
                      type="text"
                      placeholder="Kelly"
                    />
                  </div>
                </div>
                <div className="flex flex-col items-start lg:w-[180px]  xl:w-[205px]">
                  <label htmlFor="first-name" className="text-[13px] text-[#666666] font-normal">
                    Last Name
                  </label>
                  <div className="w-full">
                    <InputComponent
                      name="lastName"
                      className="border bg-[#F2F2F2] border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px] rounded p-2 w-full mb-[]"
                      type="text"
                      placeholder="Audu"
                      value={formData.lastName}
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col  items-start lg:w-[370px] xl:w-[420px] mb-[]">
                <label htmlFor="businessName" className="text-[13px] text-[#666666] font-normal mt-9">
                  Business Name
                </label>
                <div className="w-full">
                  <InputComponent
                    name="businessName"
                    className=" cursor-default border bg-[#F2F2F2] border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px]  rounded p-2 lg:w-[370px]  xl:w-[420px]"
                    type="text"
                    value={formData.businessName}
                    disabled
                    placeholder="Business Name"
                  />
                </div>
              </div>

              <div className="flex flex-col  items-start lg:w-[370px]  xl:w-[420px]">
                <label htmlFor="Category " className="text-[13px] text-[#666666] font-normal mt-5">
                  Category
                </label>
                <div className="w-full">
                  <InputComponent
                    name="industry"
                    className=" cursor-default border bg-[#F2F2F2] border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px]  rounded p-2 lg:w-[370px]  xl:w-[420px]"
                    type="text"
                    value={formData.industry}
                    disabled
                    placeholder="Category"
                  />
                </div>
              </div>
              <div className="flex flex-col  items-start lg:w-[370px]  xl:w-[420px]">
                <label htmlFor="Category " className="text-[13px] text-[#666666] font-normal mt-5">
                  Business Size
                </label>
                <div className="w-full">
                  <InputComponent
                    name="businessSize"
                    className=" cursor-default border bg-[#F2F2F2] border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px]  rounded p-2 lg:w-[370px]  xl:w-[420px]"
                    type="text"
                    value={formData.businessSize}
                    disabled
                    placeholder="Business Size"
                  />
                </div>
              </div>
            </div>

            <hr className="border-b-1 w-[] mt-[1em] ml-[-2em]" />
            <div className=" justify-start mb-[11px]">
              <div className="flex flex-col items-start mt-5  lg:w-[370px]  xl:w-[420px]">
                <label htmlFor="first-name" className="text-[13px] text-[#666666] font-normal">
                  Email
                </label>
                <div className="w-full ">
                  <InputComponent
                    name="email"
                    className="border  border-[#138EFF] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px] bg-[#F2F2F2] rounded p-2 lg:w-[370px]  xl:w-[420px] mb-[]"
                    type="text"
                    placeholder="Kelz4U@primaboost.com"
                    value={formData.email}
                    disabled
                  />
                </div>
              </div>

              <div className="flex flex-col  items-start mt-5 lg:w-[370px]  xl:w-[420px]">
                <label htmlFor="phone-number" className="text-[13px] text-[#666666] font-normal">
                  Phone Number
                </label>
                <div className="flex w-full h-[43px] border border-[#138EFF] bg-[#F2F2F2] rounded pl-2">
                  <PhoneInput
                    defaultCountry="NG"
                    className=" flex-1 w-4/6 h-fit rounded-lg gap-2 text-bold focus:outline-width-0"
                    value={formData.phone}
                    onChange={(phone) => setPhone(phone)}
                    placeholder="+234 081 8644 1442"
                    disabled
                  />
                </div>
              </div>

              <div className="flex flex-col  items-start lg:w-[370px]  xl:w-[420px]">
                <label htmlFor="Address" className="text-[13px] text-[#666666] font-normal mt-5">
                  Address
                </label>
                <div className="w-full">
                  <InputComponent
                    name="address"
                    className="border  border-[#138EFF] bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px]  rounded p-2 lg:w-[370px]  xl:w-[420px]"
                    type="text"
                    value={formData.address}
                    placeholder="Address"
                    disabled
                  />
                </div>
              </div>
              <div className="flex flex-col items-start lg:w-[370px]  xl:w-[420px]">
                <label htmlFor="State" className="text-[13px] text-[#666666] font-normal mt-5 ">
                  State
                </label>
                <div className="w-full">
                  <InputComponent
                    name="state"
                    className="border  border-[#138EFF] bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px]  rounded p-2 lg:w-[370px]  xl:w-[420px]"
                    type="text"
                    value={formData.state}
                    placeholder="State"
                    disabled
                  />
                </div>
              </div>
              <div className="flex flex-col items-start lg:w-[370px]  xl:w-[420px]">
                <label htmlFor="City" className="text-[13px] text-[#666666] font-normal mt-5">
                  City
                </label>
                <div className="w-full">
                  <InputComponent
                    name="city"
                    className="border  border-[#138EFF] bg-[#F2F2F2] placeholder:text-[1rem] placeholder:text-[#000000] placeholder:font-normal h-[48px]  rounded p-2 lg:w-[370px]  xl:w-[420px] mb-[22px]"
                    type="text"
                    value={formData.city}
                    placeholder="City"
                    disabled
                  />
                </div>
              </div>
              <hr className="border-b-1 w-[500px] mt-[-0.2em] ml-[-2em]" />

              <div className="w-64 mt-6 md:ml-[3em] xl:ml-0 lg:ml-0">
                <label htmlFor="City" className="text-[13px] text-[#666666] font-normal mt-5">
                  Logo
                </label>
                <div className="mt-4 h-[80px] w-[291px]">
                  <img src={formData.brandLogo} alt="" className="w-64 h-64 object-contain" />
                </div>
              </div>
              <div className="mt-[11.6em] mb-[2em] md:ml-[7em] xl:ml-0 lg:ml-0">
                <label htmlFor="color-input" className="text-sm text-gray-600 font-normal">
                  Brand Color
                </label>
                <div className="mt-[-1em]">
                  <input
                    type="text"
                    id="color-input"
                    className="mt-[1em] bg-white border border-gray-300 rounded-md ml-[4em] w-[100px]"
                    value={formData.brandColor}
                    readOnly
                  />
                  {formData.brandColor && (
                    <div
                      className="ml-[1em] mt-[-2em] w-6 h-6 rounded-md"
                      style={{ backgroundColor: formData.brandColor }}
                    ></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};
